export default(context) => {

    const searchType = () => {
        const { type } = context
        if (type === 'doctor' || type === 'dentist') return 'Practitioner'
        return 'Location'
    }

    return { searchType }

}